import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, Tag, Tooltip, notification } from 'antd';
import {
  EyeInvisibleOutlined,
  EyeOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons';
import { fetchUrl } from '../../lib/api';

// Admin only: a hidden tutor keeps using the platform, but students don't see
// them nor can book new lessons with them. Existing lessons are kept.

export function HiddenTag() {
  return (
    <Tooltip title="Los estudiantes no lo ven ni pueden agendar clases nuevas con él">
      <Tag color="orange" icon={<EyeInvisibleOutlined />}>
        Oculto
      </Tag>
    </Tooltip>
  );
}

function confirmToggle(tutor, onDone) {
  const fullName = `${tutor.firstName} ${tutor.lastName}`;
  const hide = !tutor.hidden;

  Modal.confirm({
    title: hide
      ? `¿Ocultar a ${fullName} a los estudiantes?`
      : `¿Mostrar a ${fullName} a los estudiantes?`,
    icon: <ExclamationCircleOutlined />,
    content: hide
      ? 'Dejará de aparecer en la lista de tutores y en la disponibilidad, y no se podrán agendar clases nuevas con él. Podrá seguir entrando y sus clases ya agendadas se mantienen.'
      : 'Volverá a aparecer en la lista de tutores y en la disponibilidad.',
    okText: hide ? 'Ocultar' : 'Mostrar',
    cancelText: 'Cancelar',
    async onOk() {
      try {
        await fetchUrl({
          method: 'PUT',
          url: `/admin/tutors/${tutor.id}`,
          data: { tutor: { hidden: hide } },
        });
        notification.success({
          message: 'Listo!',
          description: hide
            ? `${fullName} ya no aparece para los estudiantes.`
            : `${fullName} vuelve a aparecer para los estudiantes.`,
        });
        if (onDone) onDone();
      } catch (error) {
        notification.error({
          message: 'Error',
          description: error.message || 'Ha ocurrido un error al guardar',
        });
      }
    },
  });
}

export function TutorVisibilityButton({ tutor, onDone }) {
  return (
    <Button
      icon={tutor.hidden ? <EyeOutlined /> : <EyeInvisibleOutlined />}
      onClick={() => confirmToggle(tutor, onDone)}
    >
      {tutor.hidden ? 'Mostrar a estudiantes' : 'Ocultar a estudiantes'}
    </Button>
  );
}

TutorVisibilityButton.propTypes = {
  tutor: PropTypes.shape({
    id: PropTypes.number.isRequired,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    hidden: PropTypes.bool,
  }).isRequired,
  onDone: PropTypes.func,
};

TutorVisibilityButton.defaultProps = {
  onDone: null,
};
